import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ajaxGet } from '../../ajax'

const Standings = ({league}) => {
  const [standings, setStandings] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadStandings()
  }, [])

  const loadStandings = () => {
    ajaxGet(`/admins/leagues/${league.id}/standings.json`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => {
      setStandings(json.standings)
      setLoading(false)
    })
  }
  
  const pointContent = (name) => {
    switch (name)
    {
      case 'won':
        return 'W'
      case 'lost':
        return 'L'
      case 'draw':
        return 'D'
      default:
        return '-'
    }
  }

  const standingsList = () => {
    return standings.map((standing, i) => {
      return <tr key={i}>
        <td>
          <div className='team-title'>
            <span>{i+1}</span>
            <img src={standing.team_photo || '/images/leagues/team.png'} />
            <span>{standing.team_name}</span>
          </div>
        </td>
        <td>{standing.matches_played}</td>
        <td>{standing.wins}</td>
        <td>{standing.draws}</td>
        <td>{standing.loses}</td>
        <td>{standing.goals_for}</td>
        <td>{standing.goals_against}</td>
        <td>{standing.goal_diff}</td>
        <td>{standing.points}</td>
        <td>
          <div className='team-points'>
            { standing.last3.map((value, i) => {
              return <div key={i} className={['point', value].join(' ')}>{pointContent(value)}</div>
            })}
          </div>
        </td>
      </tr>
    })
  }

  return <div className='league-standings-wrapper'>
    <div id='league-standings'>
      <div className='standings-table-wrap'>
        { loading && <div className='animated-spinner'></div> }
        <table className='standings-table'>
          <thead>
            <tr>
              <th>CLUB</th>
              <th>MP</th>
              <th>W</th>
              <th>D</th>
              <th>L</th>
              <th>GF</th>
              <th>GA</th>
              <th>GD</th>
              <th>Pts</th>
              <th>LAST 3</th>
            </tr>
          </thead>
          <tbody>
            {standingsList()}
          </tbody>
        </table>
      </div>
    </div>
  </div>
}

Standings.propTypes = {
  league: PropTypes.object.isRequired,
}

export default Standings
